"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STYLE_RADIO = exports.STYLE_INVERTED_CHECKBOX = exports.STYLE_CHECKBOX = exports.STYLE_DEFAULT = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _checkbox = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/checkbox"));

var _checkActive = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/check-active-1"));

var _indeterminate = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/indeterminate-1"));

var _checkActive2 = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/check-active-2"));

var _indeterminate2 = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/indeterminate-2"));

var _radioButton = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/radio-button"));

var _radioActive = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/radio-active"));

var _keycode = _interopRequireDefault(require("keycode"));

require("./CheckBox.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noop = function noop() {};

var STYLE_DEFAULT = 'default';
exports.STYLE_DEFAULT = STYLE_DEFAULT;
var STYLE_CHECKBOX = 'checkbox';
exports.STYLE_CHECKBOX = STYLE_CHECKBOX;
var STYLE_INVERTED_CHECKBOX = 'inverted';
exports.STYLE_INVERTED_CHECKBOX = STYLE_INVERTED_CHECKBOX;
var STYLE_RADIO = 'radio';
exports.STYLE_RADIO = STYLE_RADIO;

var CheckBox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CheckBox, _React$Component);

  var _super = _createSuper(CheckBox);

  function CheckBox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CheckBox);
    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      checked: _this.props.checked,
      indeterminate: _this.props.indeterminate
    };
    return _this;
  }

  (0, _createClass2.default)(CheckBox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var state = {};

      if (nextProps.checked !== this.state.checked) {
        state.checked = nextProps.checked;
      }

      if (nextProps.indeterminate !== this.state.indeterminate) {
        state.indeterminate = nextProps.indeterminate;
      }

      this.setState(state);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var checked = this.props.type === STYLE_RADIO ? true : !this.state.checked;
      this.setState({
        checked: checked,
        indeterminate: false
      });
      this.props.onChange(checked ? this.props.value : null);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (this.props.disabled) {
        return;
      }

      this.toggle();
      this.props.onClick(e);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if (this.props.disabled) {
        return;
      }

      if (e.which === (0, _keycode.default)('Space')) {
        e.preventDefault();
        this.toggle();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Button;

      switch (this.props.style === STYLE_DEFAULT ? this.props.type === STYLE_RADIO ? STYLE_RADIO : STYLE_CHECKBOX : this.props.style) {
        case STYLE_INVERTED_CHECKBOX:
          Button = this.state.indeterminate ? _indeterminate2.default : this.state.checked ? _checkActive2.default : _checkbox.default;
          break;

        case STYLE_RADIO:
          Button = this.state.checked ? _radioActive.default : _radioButton.default;
          break;

        default:
          Button = this.state.indeterminate ? _indeterminate.default : this.state.checked ? _checkActive.default : _checkbox.default;
          break;
      }

      var label = this.props.label || this.props.children;
      var role = this.props.type === STYLE_RADIO ? STYLE_RADIO : STYLE_CHECKBOX;
      var ariaChecked = this.state.checked;
      ariaChecked = this.state.indeterminate ? 'mixed' : ariaChecked;
      var ariaLabel = this.props.ariaLabel ? this.props.ariaLabel : label;
      var className = 'primitive-checkbox';

      if (this.props.disabled) {
        className += ' disabled';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(className, " ").concat(this.props.className)
      }, /*#__PURE__*/_react.default.createElement("label", {
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-control-icon",
        tabIndex: this.props.tabIndex,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        role: role,
        "aria-label": ariaLabel,
        "aria-checked": ariaChecked
      }, /*#__PURE__*/_react.default.createElement(Button, {
        noPad: true
      })), label));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        checked: _propTypes.default.bool,
        indeterminate: _propTypes.default.bool,
        value: _propTypes.default.any,
        label: _propTypes.default.node,
        name: _propTypes.default.string,
        type: _propTypes.default.oneOf([STYLE_CHECKBOX, STYLE_RADIO]),
        style: _propTypes.default.oneOf([STYLE_DEFAULT, STYLE_CHECKBOX, STYLE_INVERTED_CHECKBOX, STYLE_RADIO]),
        onChange: _propTypes.default.func,
        onClick: _propTypes.default.func,
        onFocus: _propTypes.default.func,
        onBlur: _propTypes.default.func,
        tabIndex: _propTypes.default.number,
        className: _propTypes.default.string,
        ariaLabel: _propTypes.default.string,
        disabled: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        checked: false,
        indeterminate: false,
        value: 'on',
        label: null,
        type: STYLE_CHECKBOX,
        style: STYLE_DEFAULT,
        onChange: noop,
        onClick: noop,
        onFocus: noop,
        onBlur: noop,
        tabIndex: 0,
        className: '',
        ariaLabel: null,
        disabled: false
      };
    }
  }]);
  return CheckBox;
}(_react.default.Component);

exports.default = CheckBox;